<template>
  <div class="calendar">
    <div class="calendar-nav">
      <a v-on:click="getPrevMonth" class="btn btn-sm">前の月</a>&nbsp;{{ year }}年&nbsp;{{ displayMonth }}&nbsp;<a v-on:click="getNextMonth" class="btn btn-sm">次の月</a>
    </div>
    <div class="calendar-body">
      <table>
        <thead>
          <tr>
            <th v-for="wod in weeks">{{ wod }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dows in days">
            <td v-for="d in dows" v-bind:class="{ 'day-off': isDayOff(d) }">{{ d }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="calendar-footer">
      <div>お休み: <span class="day-off-example"></span></div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    data() {
      return {
        current: null,
        year: null,
        month: null,
        months: [
          '1月', '2月', '3月', '4月', '5月', '6月',
          '7月', '8月', '9月', '10月', '11月', '12月',
        ],
        weeks: ['日', '月', '火', '水', '木', '金', '土',],
        dayOff: {},
      };
    },

    created() {
      this.setToday();

      const db = this.$root.firebaseApp.database();
      const dayOffRef = db.ref('dayoff');
      dayOffRef.orderByKey().limitToLast(3).once('value', snapshot => {
        this.dayOff = snapshot.val();
      });
    },

    methods: {
      setToday() {
        this.current = moment();
        this.year = this.current.year();
        this.month = this.current.month();
      },

      getPrevMonth() {
        this.addMonth(-1)
      },

      getNextMonth() {
        this.addMonth(1);
      },

      addMonth(month) {
        this.current = this.current.add(month, 'month');
        this.year = this.current.year();
        this.month = this.current.month();
      },

      isDayOff(d) {
        return this.currentDayOff.find(e => { return e == d; })
      },

      chunk(array, count) {
        if (Array.isArray(array) && array.length > 0) {
          return array.reduce((accm, e, i) => {
            const rem = Math.floor(i / count);
            if (!accm[rem]) {
              accm[rem] = [];
            }
            accm[rem].push(e);
            return accm;
          }, []);
        }
        else {
          return [];
        }
      }
    },

    computed: {
      displayMonth() {
        return this.months[this.month];
      },

      days() {
        let beginningOfMonth = moment([this.year, this.month, 1]);
        let endOfMonth = this.current.endOf('month');
        let days =  [
          ...[...Array(beginningOfMonth.day()).keys()].map(_ => { return ''; }),
          ...[...Array(endOfMonth.date()).keys()].map((_, i) => { return i + 1; }),
          ...[...Array(6 - endOfMonth.day()).keys()].map(_ => { return ''; }),
        ];
        return this.chunk(days, 7);
      },
      currentDayOff() {
        const key = moment([this.year, this.month]).format('YYYYMM');
        return this.dayOff[key] || [];
      }
    },
  };
</script>



// WEBPACK FOOTER //
// Calendar.vue?1003a5ba